import { render, staticRenderFns } from "./quizleaderboard.vue?vue&type=template&id=944435bc&"
import script from "./quizleaderboard.vue?vue&type=script&lang=js&"
export * from "./quizleaderboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports